module.exports = __webpack_public_path__ + "static/media/valor2.cf9f5597.gif";